import {AnyAction, combineReducers} from 'redux';
import {uiReducer} from './ui/uiReducer';
import {signOut} from './infrastructure/auth/actions';
import {authReducer} from './infrastructure/auth/reducer';
import {dataReducer} from './data/dataReducer';

const appReducer = combineReducers({
  auth: authReducer,
  data: dataReducer,
  ui: uiReducer,
});

export const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  // State cleanup on logout
  if (signOut.fulfilled.match(action)) {
    state = undefined;
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof appReducer>;
